import React from "react";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Container from "react-bootstrap/Container";
import { AnimationOnScroll } from "react-animation-on-scroll";
import Terms from "./Terms";
import Privacy from "./Privacy";

const Legal = ({ setError }) => {
  const terms = Terms();
  const privacy = Privacy();

  return (
    <div>
      <Container fluid className="py-5 text-dark bg-light min-vh-100">
        <Row className="align-items-center my-5 py-5">
          <Col xs={{ span: 10, offset: 1 }}>
            <AnimationOnScroll duration={2} animateOnce={true} animateIn="animate__fadeIn">
              <Row className="text-start py-5 display-6">
                <Col>Legal</Col>
              </Row>
            </AnimationOnScroll>
          </Col>
        </Row>
        <AnimationOnScroll duration={2} delay={250} animateOnce={true} animateIn="animate__fadeIn">
          <Row id="termsOfUse" className="align-items-center">
            <Col xs={{ span: 10, offset: 1 }} sm={{ span: 10, offset: 1 }} className=" text-start lead">
              <Row className="">
                <Col className="small">Terms of Use</Col>
              </Row>
              <Row className="my-3 small">
                <a className="text-decoration-none text-dark" href="#privacyPolicy">
                  <Col>Skip to Privacy Policy</Col>
                </a>
              </Row>
              <Row className="my-5">
                <Col className="text-start">{terms}</Col>
              </Row>
            </Col>
          </Row>
        </AnimationOnScroll>
        <AnimationOnScroll duration={2} delay={0} animateOnce={true} animateIn="animate__fadeIn">
          <Row id="privacyPolicy" className="align-items-center">
            <Col xs={{ span: 10, offset: 1 }} sm={{ span: 10, offset: 1 }} className=" text-start lead">
              <Row className="my-5">
                <Col className="small">Privacy Policy</Col>
              </Row>
              <Row className="my-5">
                <a className="text-decoration-none text-dark" href="#termsOfUse">
                  <Col className="small">Back to Terms of Use</Col>
                </a>
              </Row>
              <Row className="my-5">
                <Col className="text-start">{privacy}</Col>
              </Row>
            </Col>
          </Row>
        </AnimationOnScroll>
      </Container>
    </div>
  );
};

export default Legal;
